import { render, staticRenderFns } from "./PositionsList.vue?vue&type=template&id=76cdd254&scoped=true&lang=pug&"
import script from "./PositionsList.vue?vue&type=script&lang=ts&"
export * from "./PositionsList.vue?vue&type=script&lang=ts&"
import style0 from "./PositionsList.vue?vue&type=style&index=0&id=76cdd254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cdd254",
  null
  
)

export default component.exports